import type { EmailActivity } from '@common/types/activities';
import { Box, Typography } from '@mui/material';
import ShowLessButton from '../ShowLessButton';
import { cleanHTML } from '../util';

interface Props {
    emailBody: EmailActivity['body'];
    isBodyExpanded: boolean;
    setIsBodyExpanded: (val: boolean) => void;
}

export default function ClientDeclineEmailBody({
    emailBody,
    isBodyExpanded,
    setIsBodyExpanded,
}: Props) {
    return (
        <Box
            sx={{
                marginTop: '16px',
                wordWrap: 'break-word',
                overflowWrap: 'anywhere',
            }}
        >
            <Typography variant="h4" sx={{ marginBottom: '16px' }}>
                Quote request response
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.primary', marginBottom: '16px' }}>
                {emailBody?.ClientName} has declined the quote with the following message:
            </Typography>
            <Typography variant="body2" color="text.primary">
                <div
                    dangerouslySetInnerHTML={{
                        __html: cleanHTML(emailBody?.ClientDeclineReason || ''),
                    }}
                ></div>
            </Typography>
            <Typography variant="h4" sx={{ marginTop: '20px' }} display="inline">
                Email:
            </Typography>
            <Typography
                variant="body2"
                sx={{ color: 'text.primary', marginLeft: '8px' }}
                display="inline"
            >
                <a href={`mailto:${emailBody?.ClientEmail}`}>{emailBody?.ClientEmail}</a>
            </Typography>
            <br />
            <Typography variant="h4" display="inline">
                Phone Number:
            </Typography>
            <Typography
                variant="body2"
                sx={{ color: 'text.primary', marginLeft: '8px' }}
                display="inline"
            >
                {emailBody?.ClientPhoneNumber}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.primary', marginTop: '16px' }}>
                You can access the prospect <a href={`${emailBody?.ProspectLink}`}>here</a>.
            </Typography>
            <ShowLessButton
                isBodyExpanded={isBodyExpanded}
                bodyExpandedHandler={setIsBodyExpanded}
            />
        </Box>
    );
}
